import { render, staticRenderFns } from "./GroupTeacherSearch.vue?vue&type=template&id=0646ace5&"
import script from "./GroupTeacherSearch.vue?vue&type=script&lang=js&"
export * from "./GroupTeacherSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports